import { Trophy, Medal, Star, Award, Crown, Flame, Zap, Heart, ThumbsUp, Target, Gem, Rocket } from 'lucide-react';

// Icon keys an admin can pick for a custom award.
export const AWARD_ICONS = {
  trophy: Trophy, medal: Medal, star: Star, award: Award, crown: Crown,
  flame: Flame, zap: Zap, heart: Heart, thumbsUp: ThumbsUp, target: Target, gem: Gem, rocket: Rocket,
};

// Color keys -> hex. Used for icon tint and card accents.
export const AWARD_COLORS = {
  gold: '#f0a92b', green: '#3fb978', blue: '#4a9eff', purple: '#c084fc',
  red: '#ef4444', orange: '#f0783a', teal: '#2dd4bf', pink: '#ec4899',
};

export const awardIcon = (key) => AWARD_ICONS[key] || Trophy;
export const awardColor = (key) => AWARD_COLORS[key] || AWARD_COLORS.gold;
